// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "path[data-v-37419a20]{fill:#7462f4;stroke-width:0px}", "",{"version":3,"sources":["webpack://./src/common/assets/icons/ZidArLogo.vue"],"names":[],"mappings":"AACA,sBACE,YAAA,CACA,gBAAA","sourcesContent":["\npath {\n  fill: #7462f4;\n  stroke-width: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
